import {cn} from '@/utils/ui';

export type JobRoleColorDotProps = {
  color?: string | null;
  className?: string;
};

const JobRoleColorDot = ({color, className}: JobRoleColorDotProps) => (
  <span
    className={cn('size-2 shrink-0 rounded-full', className)}
    style={{backgroundColor: color ?? undefined}}
    aria-hidden
  />
);

export default JobRoleColorDot;
